import ReactGA from 'react-ga';

function Discipline ({discipline, state, letterText}) {
    // ReactGA.initialize('UA-205470393-2');

    const {name, required_disclosure: requiresDisclosure, notes, contact} = discipline
    const {name: contactName, phone, email, url} = contact

    const emailInfo = `mailto:${email}?subject=Remove Medical Disclosure for ${name}s in ${state}&body=${letterText}`

    const clickedEmailAddress = () => {
        ReactGA.event({
          category: 'UserAction',
          action: 'Clicked email address',
          label: `${state} - ${name}`
        });
      }

      const clickedContactForm = () => {
        ReactGA.event({
          category: 'UserAction',
          action: 'Clicked contact form url',
          label: `${state} - ${name}`
        });
      }

    return (
        <div className="discipline">
            <h3>{name}s</h3>
             {requiresDisclosure === "Y" &&
                <div>
                    <h4>{name}s in {state} are required to disclose.</h4>
                    <p>Reach out to demand this rule is changed</p>
                    <p>{notes && <span>{notes}</span>}
                    {contactName && <span><strong>Contact: </strong>{contactName}<br/></span>}
                    {phone && <span><strong>Phone:</strong> <a href={`tel:${phone}`}>{phone}</a><br/></span>}
                    {email && <span><strong>Email:</strong> <a onClick={clickedEmailAddress} href={emailInfo}>{email}</a><br/>(<i>Click to open your email program)</i><br/><br/></span>}
                    {url && <span><strong>Contact form:</strong> <a target="_blank" rel="nofollow noreferrer" onClick={clickedContactForm} href={url}>{url}</a></span>}
                    </p>

                </div>
            }
            {requiresDisclosure === "N" &&  <div>
                <i>
                <h4>Good news!</h4>
                <p>This state does not require disclosure for {name}s.</p>
                </i>
                </div>
            } 

            {requiresDisclosure === "Unknown" &&  <div>
                <h4>We're not sure if {name}s in {state} are required to disclose.</h4>

                { (notes || contactName || phone || email || url) &&
                    <>
                    <p>You may reach out to them for confirmation</p>
                        <p>{notes && <span>{notes}</span>}
                        {contactName && <span><strong>Contact: </strong>{contactName}<br/></span>}
                        {phone && <span><strong>Phone:</strong> <a href={`tel:${phone}`}>{phone}</a><br/></span>}
                        {email && <span><strong>Email:</strong> <a href={emailInfo}>{email}</a><br/>(<i>Click to open your email program)</i><br/><br/></span>}
                        {url && <span><strong>Contact form:</strong> <a href={url}>{url}</a></span>}
                        </p>
                    </>
                }
                </div>
            } 
            
          </div>
    )

}

export default Discipline;